import React from "react";
import { Link } from "react-router-dom";
import { promoBanners } from "../mock";

const PromoBanners = () => {
  return (
    <section className="py-6 md:py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-5">
        {promoBanners.map((b) => (
          <Link
            to={b.to}
            key={b.cta}
            className="relative rounded-3xl overflow-hidden flex min-h-[220px] md:min-h-[240px] group"
            style={{ backgroundColor: b.bg }}
          >
            <div className="relative z-10 p-6 md:p-7 flex flex-col justify-between w-[58%] text-left">
              <div>
                <h3 className="font-display font-extrabold text-[22px] md:text-2xl leading-tight whitespace-pre-line" style={{ color: b.textColor }}>
                  {b.title}
                </h3>
                <p className="mt-2 text-[12.5px] font-semibold leading-snug" style={{ color: b.textColor, opacity: 0.85 }}>
                  {b.desc}
                </p>
              </div>
              <span
                className="mt-4 self-start px-5 h-9 rounded-full text-[11px] font-extrabold tracking-wider shadow-md group-hover:shadow-lg group-hover:-translate-y-0.5 transition-transform duration-200 inline-flex items-center"
                style={{ backgroundColor: b.btnBg, color: b.btnColor }}
              >
                {b.cta}
              </span>
            </div>
            <div className="absolute right-0 top-0 bottom-0 w-[46%]">
              <img
                src={b.image}
                alt={b.cta}
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                style={{ maskImage: "linear-gradient(to right, transparent 0%, black 25%)", WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 25%)" }}
              />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PromoBanners;
